import React from "react"
import Helmet from "react-helmet"
import PropTypes from "prop-types"
import { graphql, StaticQuery } from "gatsby"
import Twitter from "./twitter"
import Facebook from "./facebook"

const SEO = ({
  title = null,
  fullTitle = null,
  description = null,
  image = null,
  localImage = null,
  pathname = null,
  article = false,
}) => (
  <StaticQuery
    query={graphql`
      query SEOQuery {
        site {
          siteMetadata {
            defaultTitle: title
            titleTemplate
            defaultDescription: description
            siteUrl
            defaultImage
            twitterUsername
          }
        }
      }
    `}
    render={({
      site: {
        siteMetadata: {
          defaultTitle,
          titleTemplate,
          defaultDescription,
          siteUrl,
          defaultImage,
          twitterUsername,
        },
      },
    }) => {
      const seo = {
        title: (fullTitle ? fullTitle : (title ? title + " | Sound/Stage" : defaultTitle)),
        description: description || defaultDescription,
        image: `${image ? "https:" + image.fluid.src : (localImage ? siteUrl + localImage : siteUrl + defaultImage)}`,
        url: `${siteUrl}${pathname ? "/" + pathname : "/"}`,
      }

      return (
        <>
          <Helmet title={seo.title} titleTemplate={titleTemplate}>
            <meta
              name={`viewport`}
              content={`width=device-width, user-scalable=no`}
            />
            <meta name="description" content={seo.description} />
            <meta name="image" content={seo.image} />
            <title>{seo.title}</title>
          </Helmet>
          <Facebook
            pageUrl={seo.url}
            type={article ? "article" : null}
            title={seo.title}
            description={seo.description}
            image={seo.image}
          />
          <Twitter
            username={twitterUsername}
            title={seo.title}
            description={seo.description}
            image={seo.image}
          />
        </>
      )
    }}
  />
)

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.object,
  pathname: PropTypes.string,
  article: PropTypes.bool,
}

export default SEO
